import { render, staticRenderFns } from "./ComponenteForm.vue?vue&type=template&id=8bc5e292&scoped=true&"
import script from "./ComponenteForm.vue?vue&type=script&lang=ts&"
export * from "./ComponenteForm.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteForm.vue?vue&type=style&index=0&id=8bc5e292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc5e292",
  null
  
)

export default component.exports